import { RemoteAdminData } from 'app/infrastructure/remote-data';
import { endpoints } from './endpoints';
import { SubscriberGroupListWire } from './types';
import { SubscriberGroupsSearchModel } from './types-store';

export const api = {

  loadSubscriberGroupList: async (
    model: SubscriberGroupsSearchModel, startIndex: number, maxResults: number
  ): Promise<SubscriberGroupListWire> => {

    const response = await new RemoteAdminData(endpoints.searchSubscriberGroups)
      .resource<Response>()
      .filter({
        ...(startIndex !== undefined && { startIndex }),
        ...(maxResults !== undefined && { maxResults })
      })
      .create(model, false);

    const json = await response.json();

    return json.data;
  }
};
